/**
 * Biome terrain palettes — procedural accents on M79–M85 geometry (no sprite swap).
 */

export interface BiomeTerrainPalette {
  id: string
  grassBase: readonly [number, number, number]
  grassSoft: readonly [number, number, number]
  grassPlace: readonly [number, number, number]
  pathSubdued: number
  pathSubduedEdge: number
}

export const BIOME_TERRAIN: Record<string, BiomeTerrainPalette> = {
  grasslands: {
    id: 'grasslands',
    grassBase: [0x365f29, 0x3a662c, 0x325726],
    grassSoft: [0x3a662c, 0x3f6e30, 0x365f29],
    grassPlace: [0x3a6429, 0x3e6c2e, 0x365f26],
    pathSubdued: 0x6a5238,
    pathSubduedEdge: 0x4a3824
  },
  snow: {
    id: 'snow',
    grassBase: [0xdbe7f0, 0xd2dee8, 0xe4eef5],
    grassSoft: [0xe8f1f7, 0xd8e4ee, 0xcfdce6],
    grassPlace: [0xd0dce6, 0xc4d2de, 0xd8e4ee],
    pathSubdued: 0x7a8fa3,
    pathSubduedEdge: 0x5a6f82
  }
}

export function terrainPaletteForBiome(biomeId: string | undefined | null): BiomeTerrainPalette {
  if (biomeId && BIOME_TERRAIN[biomeId]) return BIOME_TERRAIN[biomeId]!
  return BIOME_TERRAIN.grasslands!
}
